<template>
  <div class="page">
    <div class="lesson">
      <div class="lesson-top">
        <div class="lessonTitle">{{ props.data.titleCn }}</div>
        <div class="lessonEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="lesson-bottom">
        <div class="lesson-list">
          <div class="lesson-item" v-for="(item,index) in props.data.list" @click="showVideo(item)" :key="index">
            <img class="item-img" :src="item.pic" alt="" />
            <div class="item-desc">
              <div class="desc-text">{{item.desc}}</div>
              <img src="https://p5.ssl.qhimg.com/t110b9a9301d77bf49d5dec456d.png" alt="" class="desc-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="videoDialogVisible"
      v-model="videoDialogVisible"
      width="60%"
      :show-close="false"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      align-center
    >
      <video
        autoplay
        controls
        style="width: 100%; height: auto; display: block"
        :src="currentVideo"
      ></video>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

let videoDialogVisible = ref(false)
let currentVideo = ref('')

const showVideo = (item) => {
  currentVideo.value = item.video
  videoDialogVisible.value = true
}

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .lesson {
    width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 116px;
    .lesson-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .lessonTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .lessonEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 16px;
      }
    }
    .lesson-bottom{
      width: 100%;
      margin-top: 40px;
      .lesson-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .lesson-item{
          position: relative;
          width: 455px;
          margin-top: 20px;
          border-radius: 16px;
          overflow: hidden;
          .item-img{
            cursor: pointer;
            width: 455px;
            height: 280px;
          }
          .item-desc{
            cursor: pointer;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 42px;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 12px;
            .desc-text{
              color: #fff;
              font-size: 16px;
              line-height: 42px;
              text-align: left;
              font-weight: 700;
            }
            .desc-img{
              width: 30px;
              height: 30px;
            }
          }
        }
      }
    }
  }
  /* 去除对话框 padding */
  :deep(.el-dialog) {
    padding: 0;
    background: none;
  }
  :deep(.el-dialog__header) {
    padding-bottom: 0;
  }
}
</style>
